import { useState, useRef } from "react";
import { toast } from "react-toastify";
import { reloadWindow } from "../../Helpers/Utils";
import Handler from '../../Helpers/Handler'
import AadhaarImage from '../../Assets/images/aadhaar.svg'
const UploadCard = ({ label, icon, side, file, preview, onFileChange, onClear }) => {
    const inputRef = useRef(null);
    return (
        <div className="upload-card">
            <div className="upload-card-header">
                <i className={`ti ${icon}`} aria-hidden="true" />
                <span>{label}</span>
                {file
                    ? <span className="upload-badge uploaded">Uploaded</span>
                    : <span className="upload-badge">Required</span>
                }
            </div>

            <div className={`upload-zone ${preview ? "" : ""}`}>
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={(e) => onFileChange(e, side)}
                />
                {preview ? (
                    <>
                        <img src={preview} alt={`${label} preview`} />
                        <div className="overlay-change">
                            <i className="ti ti-refresh" aria-hidden="true" /> Change
                        </div>
                    </>
                ) : (
                    <div className="upload-placeholder">
                        <i className="ti ti-upload" aria-hidden="true" />
                        <p>Click to upload</p>
                        <small>JPG, PNG, JPEG</small>
                    </div>
                )}
            </div>

            <div className="upload-card-footer">
                <span className={`file-info ${file ? "ready" : ""}`}>
                    <span className={`status-dot ${file ? "ready" : ""}`} />
                    {file
                        ? (file.name.length > 22 ? file.name.slice(0, 20) + "…" : file.name)
                        : "No file chosen"
                    }
                </span>
                {file && (
                    <button className="remove-btn" onClick={() => onClear(side)}>
                        <i className="ti ti-x" aria-hidden="true" /> Remove
                    </button>
                )}
            </div>
        </div>
    );
};

const Aadhaar = ({ requestKey }) => {
    const [showSubmit, setShowSubmit] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showDigilocker, setShowDigilocker] = useState(false);
    const [load, setLoad] = useState(false)
    const [aadhaarData, setAadhaarData] = useState({ aadhaarNo: "", frontPage: null, backPage: null, });
    const [previews, setPreviews] = useState({ front: "", back: "" });

    const handleAadhaarChange = (e) => {
        const value = e.target.value.replace(/\D/g, "").slice(0, 12);
        setAadhaarData((prev) => ({ ...prev, aadhaarNo: value }));
    };

    const handleFileChange = (e, side) => {
        const file = e.target.files[0];
        if (!file) return;
        setPreviews((prev) => ({ ...prev, [side]: URL.createObjectURL(file) }));
        setAadhaarData((prev) => ({
            ...prev,
            [side === "front" ? "frontPage" : "backPage"]: file,
        }));
    };

    const handleClear = (side) => {
        setPreviews((prev) => ({ ...prev, [side]: "" }));
        setAadhaarData((prev) => ({
            ...prev,
            [side === "front" ? "frontPage" : "backPage"]: null,
        }));
    };

    const generateLink = async () => {
        if (aadhaarData.aadhaarNo.length !== 12) {
            toast.error("Please enter a valid 12-digit Aadhaar number");
            return;
        }
        if (!aadhaarData.frontPage) {
            toast.error("Please upload the front page of your Aadhaar");
            return;
        }
        if (!aadhaarData.backPage) {
            toast.error("Please upload the back page of your Aadhaar");
            return;
        }

        setLoading(true);
        const response = await Handler({ method: 'POST', url: `/customer/aadhaar/generate`, data: { aadhaarNo: aadhaarData.aadhaarNo } })
        if (!response?.success) {
            toast.error(response?.message || "Failed to generate link");
            setLoading(false);
            return;
        }

        setShowSubmit(false);
        setShowDigilocker(true);

        window.DigiboostSdk({
            gateway: "production",
            token: response?.data?.token,
            selector: "#digilocker-button",

            onSuccess: async function () {
                const formData = new FormData();
                formData.append("clientId", response?.data?.clientId);
                formData.append("aadhaarFrontPage", aadhaarData.frontPage);
                formData.append("aadhaarBackPage", aadhaarData.backPage);
                setShowDigilocker(false);
                setLoad(true)
                const res = await Handler({ method: 'PATCH', url: `/customer/aadhaar/${requestKey}/verify`, data: formData, formData: true })
                if (res?.success) {
                    toast.success("Aadhaar verified successfully");
                    setLoad(false)
                    setTimeout(() => {
                        setLoading(false);
                        reloadWindow()
                    }, 2000);
                } else {
                    setLoading(false);
                    setLoad(false)
                    toast.error("Aadhaar verification failed");
                }
            },

            onFailure: function (error) {
                console.error("Verification failed:", error);
                toast.error("Digilocker verification failed");
                setLoading(false);
                setShowSubmit(true);
                setShowDigilocker(false);
            },
        });
    };

    const isDisabled = loading || aadhaarData.aadhaarNo.length !== 12 || !aadhaarData.frontPage || !aadhaarData.backPage;

    return (
        <div className="position-relative">
            {
                load &&
                <div className="aadhaar-loading" >
                    <div className="spinner-grow" role="status"></div>
                    <div className="spinner-grow" role="status"></div>
                    <div className="spinner-grow" role="status"></div>
                </div>
            }
            <div className="row g-3 mb-3">
                <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-center align-items-center proof-form mb-3" >
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label disabled={loading} htmlFor='aadhaarFrontPage' className={`btn me-2 ${aadhaarData?.aadhaarStatus ? "d-none" : ''}`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                aadhaarData.frontPage ?
                                    <div className="img-div">
                                        <img className="document" src={previews?.front} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload Aadhaar Front Image
                                    </div>
                            }
                        </div>
                        <input disabled={loading} id="aadhaarFrontPage" accept="image/*" className="document d-none" type="file" name="aadhaarFrontPage" onChange={(e) => handleFileChange(e, "front")} />
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <div className="d-flex justify-content-center align-items-center proof-form mb-3" >
                        <div className="proof-form-overlay"></div>
                        <div className="proof-overlay ">
                            <label disabled={loading} htmlFor='aadhaarBackPage' className={`btn me-2 ${aadhaarData?.aadhaarStatus ? "d-none" : ''}`} >Upload</label>
                        </div>
                        <div className="text-center">
                            {
                                aadhaarData.backPage ?
                                    <div className="img-div">
                                        <img className="document" src={previews?.back} alt="profile-image" width={500} height={500} />
                                    </div>
                                    :
                                    <div className="aadhaar-front">
                                        <i className="bi bi-cloud-arrow-up-fill"></i> Upload Aadhaar Back Image
                                    </div>
                            }
                        </div>
                        <input disabled={loading} id="aadhaarBackPage" accept="image/*" className="document d-none" type="file" name="aadhaarBackPage" onChange={(e) => handleFileChange(e, "back")} />
                    </div>
                </div>
            </div>
            <div className="row justify-content-center align-items-center">
                <div className="col-xs-12 col-md-5">
                    <div className="text-center"><img className="aadhaar-img" src={AadhaarImage} alt="Aadhaar" /></div>
                </div>
                <div className="col-xs-12 col-md-5">
                    <div className="mb-3">
                        <label className="form-label">Aadhaar No</label>
                        <input
                            type="text" autoComplete="off"
                            className="form-control"
                            value={aadhaarData.aadhaarNo}
                            onChange={handleAadhaarChange}
                            maxLength={12}
                            placeholder="Enter 12-digit Aadhaar number"
                        />
                        {aadhaarData.aadhaarNo && aadhaarData.aadhaarNo.length !== 12 && (
                            <small className="text-danger">
                                Aadhaar number must be 12 digits
                            </small>
                        )}
                    </div>
                    <div className="text-center mb-3">
                        {showSubmit && (<button className="btn btn-success" onClick={generateLink} disabled={isDisabled}>{loading ? "Processing..." : "Submit"}</button>)}
                        {showDigilocker && <div id="digilocker-button" />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Aadhaar;